import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SharedModule } from '../../core/shared.module';
import { LoaderService } from '../../service/loader.service';
import { Observable, Subscription, concatMap, map, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '../../service/app.service';
import { ItTableComponent, ItSortHeaderComponent, ItSortDirective, ItButtonDirective, ItSortEvent, ItCheckboxComponent, ItModalComponent, ItIconComponent, NotificationPosition, ItNotificationService, ItNotificationsComponent, ItPaginationComponent, ItBreadcrumbComponent, ItBreadcrumbItemComponent, ItBackButtonComponent } from 'design-angular-kit';
import { UtenteMaster } from '../../interfaces/utente-provisioning.interface';
import { BadgeComponent } from './badge.component';
import { UtenteComponent } from '../../shared/components/utente/utente.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { AnagraficaEnte } from '../../interfaces/anagrafica-ente.interface';
import { UtentiMasterService } from './utenti-master.service';
import { CustomValidator } from '../../shared/validators/custom.validator';
import { Utente } from '../../interfaces/user';
import { TruncatePipe } from '../../shared/pipe/truncate.pipe';
import { StatiUtenteMaster } from '../../shared/enum/stati-utente-master.enum';

@Component({
  selector: 'app-utenti-master',
  standalone: true,
  templateUrl: './utenti-master.component.html',
  imports: [
    SharedModule,
    ItModalComponent,
    UtenteComponent,
    ItIconComponent,
    ItNotificationsComponent,
    CommonModule,
    ItTableComponent,
    ItSortHeaderComponent,
    ItSortDirective,
    ItButtonDirective,
    ItCheckboxComponent,
    ItPaginationComponent,
    ItBreadcrumbComponent,
    ItBreadcrumbItemComponent,
    BadgeComponent,
    TruncatePipe,
    ItBackButtonComponent,
],
  providers: [CustomValidator],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UtentiMasterComponent implements OnInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private fb: FormBuilder,
    private appService: AppService,
    private utentiMasterService: UtentiMasterService,
    private notificationService: ItNotificationService,
    private customValidator: CustomValidator,
    private cd: ChangeDetectorRef,
  ) {
    this.nome = new FormControl(null, [Validators.required, Validators.maxLength(100), this.customValidator.noWhiteSpace()]);
    this.cognome = new FormControl(null, [Validators.required, Validators.maxLength(100), this.customValidator.noWhiteSpace()]);
    this.dataNascita = new FormControl(null, [Validators.required]);
    this.codiceFiscaleLuogoNascita = new FormControl(null);
    this.luogoNascita = new FormControl(null, [Validators.required]);
    this.sesso = new FormControl(null, [Validators.required]);
    this.codiceFiscale = new FormControl(null,
      [Validators.required, Validators.pattern(environment.regex.codiceFiscale),
      Validators.minLength(16), Validators.maxLength(16)]);
    this.email = new FormControl(null, [Validators.required, Validators.pattern(environment.regex.email)]);
    this.confermaEmail = new FormControl(null, [Validators.required, Validators.pattern(environment.regex.email)]);
    this.telefono = new FormControl(null, [Validators.required, Validators.maxLength(50), Validators.pattern(environment.regex.telefono), this.customValidator.noWhiteSpace()]);
  }
  pageSubscription = new Subscription();
  listEnti: AnagraficaEnte[] = [];
  items: any[] = [];

  cognome: FormControl;
  nome: FormControl;
  dataNascita: FormControl;
  codiceFiscaleLuogoNascita: FormControl;
  luogoNascita: FormControl;
  sesso: FormControl;
  codiceFiscale: FormControl;
  email: FormControl;
  confermaEmail: FormControl;
  telefono: FormControl;

  maxLengthCF: number = 16;
  form: FormGroup = this.fb.group({});
  idUtenteMaster: number = 0;
  utenti: UtenteMaster[] = [];
  ente: AnagraficaEnte = {};
  user: Utente = {};
  reset: boolean = false;
  editMode: boolean = false;
  editable: boolean = true;
  totalPages: number = 0;
  currentPage: number = 0;
  pageOffset: number = 10;

  @ViewChild('utenteMasterModal') utenteMasterModal!: ItModalComponent;
  @ViewChild('abilitaModal') abilitaModal!: ItModalComponent;

  ngOnInit(): void {
    this.loaderService.hide();
    this.ente = this.appService.ente;
    this.user = this.appService.user;
    this.initBreadcrumb();
    this.utenti = this.route.snapshot.data['data'];
    this.getPage();
  }

  initBreadcrumb(): void {
    if (!this.user.isUtenteAdmin) {
      this.items = [
        { label: 'Home', link: '/ente' },
        { label: 'Utenti Master' },
      ];
    } else {
      this.items = [
        { label: 'Home', link: '/home' },
        { label: `${this.ente.ragioneSociale}`, link: '/ente' },
        { label: 'Utenti Master' },
      ];
    }
  }

  add(): void {
    this.reset = !this.reset;
    this.idUtenteMaster = 0;
    this.editable = true;
    this.form.enable();
    this.utenteMasterModal.show();
  }

  edit(element: UtenteMaster) {
    this.utenteMasterModal.show();
    this.idUtenteMaster = element.idUtenteMaster ?? 0;
    element.dataNascita = element.dataNascita?.split('T')[0];
    this.editable = (!element.flagPrincipale && !element.flagPrivacy && element.statoUtenteMaster?.consenteModifica && element.codiceFiscale != this.user.idUtente && !this.ente.isSolaLettura) ?? false;
    if (this.editable) {
      this.form.enable();
    }
    this.nome.setValue(element.nome, { emitEvent : false });
    this.cognome.setValue(element.cognome, { emitEvent : false });
    this.sesso.setValue(element.sesso, { emitEvent : false });
    this.luogoNascita.setValue(element.comuneNascita?.toLocaleUpperCase(), { emitEvent : false });
    this.form.get('utenteProvisioning')?.get('codiceFiscaleLuogoNascita')?.setValue(element.codiceComuneNascita, { emitEvent : false });
    this.dataNascita.setValue(element.dataNascita, { emitEvent : false });
    this.email.setValue(element.email, { emitEvent : false });
    this.confermaEmail.setValue(element.email, { emitEvent : false });
    this.telefono.setValue(element.telefono, { emitEvent : false });
    this.codiceFiscale.setValue(element.codiceFiscale, { emitEvent : false });
    this.editMode = !this.editMode;
    if (element.statoUtenteMaster?.idStatoUtenteMaster !== StatiUtenteMaster.InBozza) {
      this.email.disable({ emitEvent : false });
      this.confermaEmail.disable({ emitEvent : false });
    }
  }

  listInit(el: UtenteMaster[]) {
    this.utenti = el;
    this.cd.detectChanges();
  }

  sortData(event: ItSortEvent) {
    this.getPage(this.currentPage, event);
  }

  submit(): void {
    if (this.form.invalid) {
      return;
    }
    const formValues = this.form.getRawValue().utenteProvisioning;
    const dataToSend = {
      idUtenteMaster: this.idUtenteMaster,
      nome: formValues.nome,
      cognome: formValues.cognome,
      sesso: formValues.sesso,
      codiceComuneNascita: formValues.codiceFiscaleLuogoNascita,
      comuneNascita: formValues.luogoNascita,
      dataNascita: formValues.dataNascita,
      codiceFiscale: formValues.codiceFiscale,
      email: formValues.email,
      telefono: formValues.telefono,
      isBozza: true,
    }
    this.pageSubscription.add(
      this.utentiMasterService.post(dataToSend).pipe(
        concatMap((result) => {
          if (result) {
            this.utenteMasterModal.hide();
            this.loaderService.show();
            return this.utentiMasterService.list();
          }
          return of(null);
        })
      )
      .subscribe({
        next: (el: UtenteMaster[]) => {
        if (el) {
          this.notificationService.success(
            `Dati ${
              this.idUtenteMaster ? 'modificati' : 'salvati'
            } con successo!`, '', false, 3000, NotificationPosition.Bottom
          );
          this.getPage();
        }
      },
      error: () => this.loaderService.hide(),
      complete: () => this.loaderService.hide(),
    }));
  }

  getPage(page: number = 0, sort?: ItSortEvent): void {
    this.paginator(page, this.pageOffset)
      .subscribe(data => {
        data.list = data.list.sort((a, b) => {
          if (sort?.direction === 'asc') {
            return a[sort.active] > b[sort.active] ? 1 : -1;
          } else if (sort?.direction === 'desc') {
            return a[sort.active] < b[sort.active] ? 1 : -1;
          }
          return 0;
        });
        this.listInit(data.list);
        this.currentPage = page;
        this.totalPages = Math.ceil(data.totalItemsCount / this.pageOffset);
      });
  }

  changerEvent(value: number): void {
    this.pageOffset = value;
    this.getPage();
  }

  private paginator(page: number, pageOffset: number): Observable<{ list: UtenteMaster[]; totalItemsCount: number }> {
    return this.utentiMasterService.list().pipe(
      map((data: UtenteMaster[]) => {
        const startIndex = page * pageOffset;
        const endIndex = startIndex + pageOffset;
        const list = data.slice(startIndex, endIndex);
        return {
          list: list,
          totalItemsCount: data.length,
        };
      })
    );
  }

  confirmData(element: UtenteMaster): void {
    element.isBozza = false;
    this.pageSubscription.add(
      this.utentiMasterService.post(element).pipe(
        concatMap((result) => {
          if (result) {
            this.abilitaModal.hide();
            this.loaderService.show();
            return this.utentiMasterService.list();
          }
          return of(null);
        })
      )
      .subscribe({
        next: (el: UtenteMaster[]) => {
        if (el) {
          this.notificationService.success(
            `Dati ${
              this.idUtenteMaster ? 'modificati' : 'salvati'
            } con successo!`, '', false, 3000, NotificationPosition.Bottom
          );
          this.getPage();
        }
      },
      error: () => this.loaderService.hide(),
      complete: () => this.loaderService.hide(),
    }));

  }

  delete(element: UtenteMaster): void {
    if (element.isSolaLettura) {
      return;
    }
    this.pageSubscription.add(
      this.utentiMasterService.delete(element.idUtenteMaster).pipe(
        concatMap((result) => {
          if (result) {
            this.loaderService.show();
            return this.utentiMasterService.list();
          }
          return of(null);
        })
      )
      .subscribe({
        next: (el: UtenteMaster[]) => {
        if (el) {
          this.notificationService.success(
            'Dati eliminati con successo!', '', false, 3000, NotificationPosition.Bottom
          );
          this.getPage();
        }
      },
      error: () => this.loaderService.hide(),
      complete: () => this.loaderService.hide(),
    }));
  }

  ngOnDestroy(): void {
    this.pageSubscription.unsubscribe();
  }
}
